import React from 'react';
import { Typography } from 'fronton-react';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { LinkWrapper, text } from './styles';
import { ChevronLeftIcon } from '@fronton/icons-react';

type MainPageLinkProps = {
	link: string;
};

export const MainPageLink = ({ link }: MainPageLinkProps) => {
	const clickHandler = () => {
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: 'breadcrumbs',
			elementText: 'Все услуги',
		});
	};
	return (
		<LinkWrapper href={link}>
			<ChevronLeftIcon type="outline" size="m" color="text-minor" />
			<Typography className={text} variant="s" size="body_short" onClick={clickHandler}>
				Все услуги
			</Typography>
		</LinkWrapper>
	);
};
